


















import { notNullOrUndefined } from "@/utility/functions";
import Component from "vue-class-component";
import Vue from "vue";
import { Prop, VModel } from "vue-property-decorator";

@Component({})
export default class TextField extends Vue {
  @VModel({ default: "" }) localValue!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: () => [] }) rules!: Array<string>;
  @Prop({ default: "" }) placeholder!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: null }) success!: boolean;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: undefined }) vid!: string;
  @Prop({ default: true }) outlined!: boolean;
  @Prop({ default: false }) shaped!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) prependIcon!: string;
  @Prop({ default: "" }) type!: string;
  @Prop({ default: true }) dense!: boolean;
  @Prop({ default: null }) prependInnerIcon!: string;
  @Prop({ default: () => [] }) errors!: [];

  get isRequired(): boolean {
    return this.rules.includes("required");
  }
  get getPrependInnerIcon(): string {
    if (notNullOrUndefined(this.prependInnerIcon)) {
      return this.prependInnerIcon;
    } else {
      return this.isRequired ? "mdi-asterisk" : "";
    }
  }
}
